module.exports = __webpack_public_path__ + "images/category_lp/smartphone/store_images/5_e2c5c2a1e99d7b13e3f16c2b7147ad3a.png";